import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {objectContentElementInitialState, updateState,} from "../../../../common/utils/helpers";

const initialState = {
  creationNouveauPackage: { ...objectContentElementInitialState },
};

/*-------------------------------------------------CREATION-NOUVEAU-PACKAGE----------------------------------------------------*/
const creationNouveauPackage = (state) => {
  return updateState("creationNouveauPackage", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const creationNouveauPackageSuccess = (state, payload) => {
  return updateState("creationNouveauPackage", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const creationNouveauPackageFail = (state, payload) => {
  return updateState("creationNouveauPackage", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const creationNouveauPackageReinitialization = (state) => {
  return updateState("creationNouveauPackage", state, {
    ...objectContentElementInitialState,
  });
};

/*************************************************************************** */
const nouveauPackageReducer = (state = initialState, action) => {
  switch (action.type) {
    /*-------------------------------------------------CREATION-NOUVEAU-PACKAGE----------------------------------------------------*/
    case ActionsTypes.CREATION_NOUVEAU_PACKAGE:
      return creationNouveauPackage(state, action);
    case ActionsTypes.CREATION_NOUVEAU_PACKAGE_SUCCESS:
      return creationNouveauPackageSuccess(state, action.payload);
    case ActionsTypes.CREATION_NOUVEAU_PACKAGE_FAIL:
      return creationNouveauPackageFail(state, action.payload);
    case ActionsTypes.CREATION_NOUVEAU_PACKAGE_REINITIALIZATION:
      return creationNouveauPackageReinitialization(state, action.payload);
    default:
      return state;
  }
};

export default nouveauPackageReducer;
